export const chatTranslations = {
  fr: {
    title: "Chatbot I.A médical",
    titleShort: "Chatbot I.A",
    subtitle: "Votre assistant médical intelligent",
    back: "Retour",
    placeholder: "Posez votre question médicale...",
    inputPlaceholder: "Tapez votre message ici...",
    send: "Envoyer",
    clear: "Effacer",
    thinking: "L'IA réfléchit...",
    typing: "Écriture...",
    loading: "Chargement...",
    startConversation: "Commencez une nouvelle conversation",
    askQuestion: "Posez votre question médicale ou décrivez votre cas clinique",
    currentMode: "Mode actuel",
    errorMessage: "Erreur lors de l'envoi du message",
    welcomeMessage: "Bonjour ! Je suis votre assistant IA médical. Comment puis-je vous aider aujourd'hui ?",
    disclaimer: "Les réponses sont générées par IA et ne remplacent pas un avis médical. Vérifiez les informations et consultez un professionnel de santé.",
    
    // Navigation et conversation
    newConversation: "Nouvelle conversation",
    newConversationDefault: "Nouvelle conversation",
    conversations: "Conversations",
    noConversations: "Aucune conversation",
    assistanceMode: "Mode d'assistance",
    processingSpeed: "Vitesse de traitement",
    history: "Historique",
    deleteConversationConfirm: "Supprimer cette conversation ?",
    closeSidebar: "Fermer le menu",
    
    // Modes de prompt
    modes: {
      general: "Général",
      diagnostic: "Aide au diagnostic",
      priseEnCharge: "Prise en charge",
      formation: "Formation",
      these: "Recherche/Thèse",
      pmsi: "PMSI/Codage",
      rsca: "RSCA",
      analysePrescriptions: "Prescriptions",
      casComplexes: "Cas complexes"
    },
    
    // Descriptions des modes
    modeDescriptions: {
      general: "Questions générales et discussions ouvertes",
      diagnostic: "Assistance pour l'établissement de diagnostics",
      priseEnCharge: "Conseils pour la prise en charge thérapeutique",
      formation: "Support pédagogique et apprentissage",
      these: "Aide à la recherche et rédaction académique",
      pmsi: "Codage médical et analyse PMSI",
      rsca: "Révision systématique et conformité d'audit",
      analysePrescriptions: "Vérification et analyse des prescriptions",
      casComplexes: "Résolution de cas médicaux complexes"
    },
    
    // Modes de vitesse
    speedModes: {
      normal: "Normal",
      fast: "Rapide",
      extreme: "Extrême"
    },
    
    // Descriptions des vitesses
    speedDescriptions: {
      normal: "Réponses complètes et détaillées (recommandé)",
      fast: "Réponses concises et rapides",
      extreme: "Réponses très courtes et immédiates"
    },
    
    // Actions
    actions: {
      createFlashcards: "Créer des cartes",
      createRevisionSheet: "Fiche de révision",
      createStudyContent: "Créer QCM/Cas",
      generate: "Générer"
    },
    studyGeneration: {
      title: "Créer du contenu d'étude",
      contentType: "Type de contenu",
      qcm: "QCM",
      clinicalCase: "Cas clinique",
      difficulty: "Niveau de difficulté",
      easy: "Facile",
      medium: "Moyen",
      hard: "Difficile",
      expert: "Expert",
      questionCount: "Nombre de questions",
      questions: "questions",
      generate: "Générer",
      generating: "Génération...",
      success: "contenu d'étude généré avec succès !",
      error: "Erreur lors de la génération du contenu"
    },
    
    // Interface
    welcomeTitle: "Bienvenue sur Sclépios IA",
    welcomeDescription: "Votre assistant médical intelligent est prêt à vous aider. Posez votre première question pour commencer une conversation.",
    responseSpeed: "Vitesse de réponse",
    description: "Assistant IA médical pour diagnostics, formations et conseils médicaux",
    
    // Authentification
    auth: {
      loginRequired: "Connexion requise",
      loginRequiredDescription: "Vous devez être connecté pour utiliser le chat IA.",
      login: "Se connecter"
    },
    
    // Messages de toast
    toasts: {
      conversationDeleted: "Conversation supprimée",
      messageCopied: "Message copié",
      messageCopiedDesc: "Le contenu a été copié dans le presse-papiers",
      messageCopyError: "Impossible de copier le message",
      flashcardsGenerated: "cartes créées avec succès",
      revisionSheetGenerated: "Fiche de révision générée avec succès"
    },
    
    // Erreurs
    errors: {
      loadConversations: "Erreur lors du chargement des conversations",
      loadMessages: "Erreur lors du chargement des messages",
      invalidSession: "Session invalide",
      serverError: "Erreur serveur",
      noResponse: "Aucune réponse reçue",
      sendMessage: "Erreur lors de l'envoi du message",
      connectionError: "Erreur de connexion",
      sessionExpired: "Session expirée",
      tooManyRequests: "Trop de requêtes",
      timeout: "Délai d'attente dépassé",
      deleteConversation: "Erreur lors de la suppression",
      copyMessage: "Erreur lors de la copie",
      noConversationSelected: "Aucune conversation sélectionnée",
      emptyConversation: "Conversation vide",
      generationError: "Erreur de génération"
    },
    
    suggestions: {
      title: "Suggestions",
      diagnosis: "Aide au diagnostic",
      medication: "Information sur les médicaments",
      guidelines: "Recommandations cliniques"
    },
    
    // Mobile interface
    openSidebar: "Ouvrir le menu",
    newMessages: "Nouveaux messages",
    followThread: "Revenir en bas"
  },
  en: {
    title: "Medical I.A Chatbot",
    titleShort: "I.A Chatbot",
    subtitle: "Your intelligent medical assistant",
    back: "Back",
    placeholder: "Ask your medical question...",
    inputPlaceholder: "Type your message here...",
    send: "Send",
    clear: "Clear",
    thinking: "AI is thinking...",
    typing: "Typing...",
    loading: "Loading...",
    startConversation: "Start a new conversation",
    askQuestion: "Ask your medical question or describe your clinical case",
    currentMode: "Current mode",
    errorMessage: "Error sending message",
    welcomeMessage: "Hello! I'm your medical AI assistant. How can I help you today?",
    disclaimer: "AI-generated responses do not replace medical advice. Verify information and consult a healthcare professional.",
    
    // Navigation and conversation
    newConversation: "New conversation",
    newConversationDefault: "New conversation",
    conversations: "Conversations",
    noConversations: "No conversations",
    assistanceMode: "Assistance mode",
    processingSpeed: "Processing speed",
    history: "History",
    deleteConversationConfirm: "Delete this conversation?",
    closeSidebar: "Close menu",
    
    // Prompt modes
    modes: {
      general: "General",
      diagnostic: "Diagnostic help",
      priseEnCharge: "Patient care",
      formation: "Training",
      these: "Research/Thesis",
      pmsi: "PMSI/Coding",
      rsca: "RSCA",
      analysePrescriptions: "Prescriptions",
      casComplexes: "Complex cases"
    },
    
    // Mode descriptions
    modeDescriptions: {
      general: "General questions and open discussions",
      diagnostic: "Assistance for establishing diagnoses",
      priseEnCharge: "Therapeutic management advice",
      formation: "Educational support and learning",
      these: "Research and academic writing assistance",
      pmsi: "Medical coding and PMSI analysis",
      rsca: "Systematic review and audit compliance",
      analysePrescriptions: "Prescription verification and analysis",
      casComplexes: "Complex medical case resolution"
    },
    
    // Speed modes
    speedModes: {
      normal: "Normal",
      fast: "Fast",
      extreme: "Extreme"
    },
    
    // Speed descriptions
    speedDescriptions: {
      normal: "Complete and detailed responses (recommended)",
      fast: "Concise and quick responses",
      extreme: "Very short and immediate responses"
    },
    
    // Actions
    actions: {
      createFlashcards: "Create cards",
      createRevisionSheet: "Revision sheet",
      createStudyContent: "Create Quiz/Case",
      generate: "Generate"
    },
    studyGeneration: {
      title: "Create study content",
      contentType: "Content type",
      qcm: "Quiz",
      clinicalCase: "Clinical case",
      difficulty: "Difficulty level",
      easy: "Easy",
      medium: "Medium",
      hard: "Hard",
      expert: "Expert",
      questionCount: "Number of questions",
      questions: "questions",
      generate: "Generate",
      generating: "Generating...",
      success: "study content generated successfully!",
      error: "Error generating study content"
    },
    
    // Interface
    welcomeTitle: "Welcome to Sclepios AI",
    welcomeDescription: "Your intelligent medical assistant is ready to help. Ask your first question to start a conversation.",
    responseSpeed: "Response speed",
    description: "Medical AI assistant for diagnostics, training and medical advice",
    
    // Authentication
    auth: {
      loginRequired: "Login required",
      loginRequiredDescription: "You must be logged in to use the AI chat.",
      login: "Login"
    },
    
    // Toast messages
    toasts: {
      conversationDeleted: "Conversation deleted",
      messageCopied: "Message copied",
      messageCopiedDesc: "Content has been copied to clipboard",
      messageCopyError: "Unable to copy the message",
      flashcardsGenerated: "cards created successfully",
      revisionSheetGenerated: "Revision sheet generated successfully"
    },
    
    // Errors
    errors: {
      loadConversations: "Error loading conversations",
      loadMessages: "Error loading messages",
      invalidSession: "Invalid session",
      serverError: "Server error",
      noResponse: "No response received",
      sendMessage: "Error sending message",
      connectionError: "Connection error",
      sessionExpired: "Session expired",
      tooManyRequests: "Too many requests",
      timeout: "Timeout exceeded",
      deleteConversation: "Error deleting conversation",
      copyMessage: "Error copying message",
      noConversationSelected: "No conversation selected",
      emptyConversation: "Empty conversation",
      generationError: "Generation error"
    },
    
    suggestions: {
      title: "Suggestions",
      diagnosis: "Diagnostic help",
      medication: "Medication information",
      guidelines: "Clinical guidelines"
    },
    
    // Mobile interface
    openSidebar: "Open menu",
    newMessages: "New messages",
    followThread: "Back to bottom"
  },
  es: {
    title: "Chatbot I.A médico",
    titleShort: "Chatbot I.A",
    subtitle: "Tu asistente médico inteligente",
    back: "Volver",
    placeholder: "Haz tu pregunta médica...",
    inputPlaceholder: "Escribe tu mensaje aquí...",
    send: "Enviar",
    clear: "Limpiar",
    thinking: "La IA está pensando...",
    typing: "Escribiendo...",
    loading: "Cargando...",
    startConversation: "Iniciar nueva conversación",
    askQuestion: "Haz tu pregunta médica o describe tu caso clínico",
    currentMode: "Modo actual",
    errorMessage: "Error al enviar mensaje",
    welcomeMessage: "¡Hola! Soy tu asistente IA médico. ¿Cómo puedo ayudarte hoy?",
    disclaimer: "Las respuestas generadas por IA no sustituyen el consejo médico. Verifica la información y consulta a un profesional de la salud.",
    
    // Navegación y conversación
    newConversation: "Nueva conversación",
    newConversationDefault: "Nueva conversación",
    conversations: "Conversaciones",
    noConversations: "Sin conversaciones",
    assistanceMode: "Modo de asistencia",
    processingSpeed: "Velocidad de procesamiento",
    history: "Historial",
    deleteConversationConfirm: "¿Eliminar esta conversación?",
    closeSidebar: "Cerrar menú",
    
    // Modos de prompt
    modes: {
      general: "General",
      diagnostic: "Ayuda diagnóstica",
      priseEnCharge: "Atención al paciente",
      formation: "Formación",
      these: "Investigación/Tesis",
      pmsi: "PMSI/Codificación",
      rsca: "RSCA",
      analysePrescriptions: "Prescripciones",
      casComplexes: "Casos complejos"
    },
    
    // Descripciones de modos
    modeDescriptions: {
      general: "Preguntas generales y discusiones abiertas",
      diagnostic: "Asistencia para establecer diagnósticos",
      priseEnCharge: "Consejos de manejo terapéutico",
      formation: "Apoyo educativo y aprendizaje",
      these: "Asistencia en investigación y redacción académica",
      pmsi: "Codificación médica y análisis PMSI",
      rsca: "Revisión sistemática y cumplimiento de auditoría",
      analysePrescriptions: "Verificación y análisis de prescripciones",
      casComplexes: "Resolución de casos médicos complejos"
    },
    
    // Modos de velocidad
    speedModes: {
      normal: "Normal",
      fast: "Rápido",
      extreme: "Extremo"
    },
    
    // Descripciones de velocidad
    speedDescriptions: {
      normal: "Respuestas completas y detalladas (recomendado)",
      fast: "Respuestas concisas y rápidas",
      extreme: "Respuestas muy cortas e inmediatas"
    },
    
    // Acciones
    actions: {
      createFlashcards: "Crear tarjetas",
      createRevisionSheet: "Hoja de revisión",
      createStudyContent: "Crear Quiz/Caso",
      generate: "Generar"
    },
    studyGeneration: {
      title: "Crear contenido de estudio",
      contentType: "Tipo de contenido",
      qcm: "Quiz",
      clinicalCase: "Caso clínico",
      difficulty: "Nivel de dificultad",
      easy: "Fácil",
      medium: "Medio",
      hard: "Difícil",
      expert: "Experto",
      questionCount: "Número de preguntas",
      questions: "preguntas",
      generate: "Generar",
      generating: "Generando...",
      success: "contenido de estudio generado con éxito!",
      error: "Error al generar el contenido de estudio"
    },
    
    // Interfaz
    welcomeTitle: "Bienvenido a Sclepios IA",
    welcomeDescription: "Tu asistente médico inteligente está listo para ayudar. Haz tu primera pregunta para comenzar una conversación.",
    responseSpeed: "Velocidad de respuesta",
    description: "Asistente IA médico para diagnósticos, formación y consejos médicos",
    
    // Autenticación
    auth: {
      loginRequired: "Inicio de sesión requerido",
      loginRequiredDescription: "Debes iniciar sesión para usar el chat IA.",
      login: "Iniciar sesión"
    },
    
    // Mensajes de toast
    toasts: {
      conversationDeleted: "Conversación eliminada",
      messageCopied: "Mensaje copiado",
      messageCopiedDesc: "El contenido se ha copiado al portapapeles",
      messageCopyError: "No se pudo copiar el mensaje",
      flashcardsGenerated: "tarjetas creadas exitosamente",
      revisionSheetGenerated: "Hoja de revisión generada exitosamente"
    },
    
    // Errores
    errors: {
      loadConversations: "Error al cargar conversaciones",
      loadMessages: "Error al cargar mensajes",
      invalidSession: "Sesión inválida",
      serverError: "Error del servidor",
      noResponse: "No se recibió respuesta",
      sendMessage: "Error al enviar mensaje",
      connectionError: "Error de conexión",
      sessionExpired: "Sesión expirada",
      tooManyRequests: "Demasiadas solicitudes",
      timeout: "Tiempo de espera agotado",
      deleteConversation: "Error al eliminar conversación",
      copyMessage: "Error al copiar mensaje",
      noConversationSelected: "No hay conversación seleccionada",
      emptyConversation: "Conversación vacía",
      generationError: "Error de generación"
    },
    
    suggestions: {
      title: "Sugerencias",
      diagnosis: "Ayuda de diagnóstico",
      medication: "Información de medicamentos",
      guidelines: "Guías clínicas"
    },
    
    // Mobile interface
    openSidebar: "Abrir menú",
    newMessages: "Nuevos mensajes",
    followThread: "Volver abajo"
  }
};